<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="tw-fill-black dark:tw-fill-white" viewBox="0 0 16 14"><path d="M14.17 0a1 1 0 0 1 .7 1.71L9.58 7l5.3 5.29a1 1 0 1 1-1.42 1.42l-6-6a1 1 0 0 1 0-1.42l6-6a1 1 0 0 1 .71-.29m-8 0a1 1 0 0 1 .7 1.71l-4.6 4.58a1 1 0 0 0 0 1.42l4.6 4.58a1 1 0 1 1-1.4 1.42L.86 9.12a3 3 0 0 1 0-4.24L5.47.29a1 1 0 0 1 .7-.29"/></svg>
</template>
